export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || '';
export const REACT_APP_CLIENT_URL = process.env.REACT_APP_CLIENT_URL || 'http://localhost:3050';

export const CHAT_DTC_TITLE = 'Chat DTC';

export const INVALID_PROMPT_MESSAGE = 'Invalid Prompt: Question is unrelated to data set.' as const;
